let items = [
  {
    name: "LABORATORY",
    active: false,
    subs: [
      {
        name: "Prescriptions",
        url: "/laboratory/prescription",
        icon: "fas fa-file-prescription"
      },
      {
        name: "Patientèle",
        url: "/laboratory/patients",
        icon: "fas fa-user-injured"
      }
    ]
  },
  {
    name: "ADMINISTRATION",
    active: false,
    subs: [
      {
        name: "Configurations",
        url: "/laboratory/setting",
        icon: "fas fa-cog"
      },
      {
        name: "Utilisateurs",
        url: "/laboratory/users",
        icon: "fas fa-user-lock"
      },
      {
        name: "Support",
        url: "/laboratory/support",
        icon: "fas fa-info-circle"
      }
    ]
  },
  {
    name: "SECTION THREE",
    subs: [
      {
        name: "Se Deconnecter",
        function: () => {
          localStorage.removeItem("userInfo");
          localStorage.removeItem("userRole");
          localStorage.removeItem("accessToken");
          window.location.pathname = "/";
        },
        icon: "fas fa-sign-out-alt"
      }
    ]
  }
];
let items_member = [
  {
    name: "LABORATORY",
    active: false,
    subs: [
      {
        name: "Prescriptions",
        url: "/laboratory/prescription",
        icon: "fas fa-file-prescription"
      },
      {
        name: "Patientèle",
        url: "/laboratory/patients",
        icon: "fas fa-user-injured"
      }
    ]
  },
  {
    name: "ADMINISTRATION",
    active: false,
    subs: [
      {
        name: "Configurations",
        url: "/laboratory/setting",
        icon: "fas fa-cog"
      },
      {
        name: "Support",
        url: "/laboratory/support",
        icon: "fas fa-info-circle"
      }
    ]
  },
  {
    name: "SECTION THREE",
    subs: [
      {
        name: "Se Deconnecter",
        function: () => {
          localStorage.removeItem("userInfo");
          localStorage.removeItem("userRole");
          localStorage.removeItem("accessToken");
          window.location.pathname = "/";
        },
        icon: "fas fa-sign-out-alt"
      }
    ]
  }
];

let all_items = {
  items: items,
  items_member: items_member
};
export default all_items;
